import React, { Component } from 'react';
import FigmaButton from '../../../Elements/FigmaButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OverWindow from '../../../Elements/TabList/OverWindow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import TpClientInvoiceReducedListItem from '../../../Domain/TpClientInvoiceReducedListItem';
import TpClientInvoiceStatusEnum from '../../../Enums/ClientInvoiceStatusEnum';

export default class AddToTpClientInvoicePanel extends Component {
  static defaultProps = {
    clientId: 0,
    searchParameters: null,
    selected: [],
    allItemsInTheSearchAreSelected: false,
    refresh: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      saving: false,
      searchItem: { ClientNameOrId: this.props.clientId, Statuses: [TpClientInvoiceStatusEnum.Draft] },
    };

    TpClientInvoiceReducedListItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  clickOnSelect(item) {
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      element.Selected = element.TpClientInvoiceId === item.TpClientInvoiceId ? !element.Selected : false;
    });
    this.setState({
      itemList: templist,
    });
  }

  handleOnSubmit() {
    this.setState({ saving: true });

    TpClientInvoiceService.AddToInvoice(
      { TpClientInvoiceId: this.state.itemList.find((f) => f.Selected).TpClientInvoiceId },
      this.props.searchParameters,
      this.props.selected,
      this.props.allItemsInTheSearchAreSelected
    ).catch(() => {
      ErrorMessage.SetErrorMessage('PIS153');
      this.setState({ saving: false });
    });
    ErrorMessage.SetNotification(
      'Started adding jobs to the invoice in the background. You will receive an in-app notification when the process is done.'
    );

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        altKey: false,
        code: 'Escape',
        ctrlKey: false,
        isComposing: false,
        key: 'Escape',
        location: 0,
        metaKey: false,
        repeat: false,
        shiftKey: false,
        which: 27,
        charCode: 0,
        keyCode: 27,
      })
    );
  }

  renderCancelAndSubmitButtons() {
    return (
      <ButtonFooterContainer>
        <FigmaButton
          className='applySurveyPanelButton'
          label='Add To Invoice'
          submit={true}
          iconName={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
          disabled={this.state.saving || !this.state.itemList.find((f) => f.Selected)}
          type={ButtonTypeEnum.ExtraLargeNormal}
          color={ButtonColorsEnum.Primary}
          iconPosition={IconPositionEnum.Left}
          onClick={() => this.handleOnSubmit()}
        />
      </ButtonFooterContainer>
    );
  }

  render() {
    return (
      <OverWindow
        title={'Choose Client Invoice'}
        clickOnCancel={() => {
          if (!this.state.saving) this.props.refresh(false);
        }}
        closeOnClickOutside={false}
        iconName='fa-solid fa-plus-circle'
        zIndex={1050}
        className='applySurveyPanel top-of-boxFigma'
        verticalScroll={false}
      >
        <div className='container-fluid verticalScrollForSearch height50vh'>
          <TabOfDataTable
            itemList={this.state.itemList}
            type={TpClientInvoiceReducedListItem}
            serviceFunction={TpClientInvoiceService.GetSimpleListBySearching}
            changeOfItemListFunction={(itemList) => this.setState({ itemList })}
            convertDBItemsFunction={TpClientInvoiceService.ConvertReducedDBItems}
            enableUrlPush={false}
            searchItem={this.state.searchItem}
            orderBy='TpClientInvoiceId'
            orderDirection='Desc'
          />
          {this.renderCancelAndSubmitButtons()}
        </div>
      </OverWindow>
    );
  }
}
